export type { AcademyDetail_educationAcademy_academyConfiguration_skillPath_activeSkillPathConfiguration_skillPathCourses_course as CourseNode } from './graphql/types/AcademyDetail';
export * from './graphql/types/AcademyDetail';
export { default } from './useAcademyDetail';
